import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// Create axios instance with base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://rebase.api.seasideapis.com',
  headers: {
    'Accept': 'applicant api; version=1',
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');

    // Don't override an Authorization header already set on the request
    // (e.g. the reset_token passed by resetPassword) with the stored auth_token.
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Preserve custom Accept header if it's set in the request config
    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'applicant api; version=1';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Clear local storage if not on login/register pages
      const currentRoute = `${window.location.pathname}${window.location.hash}`;
      const isAuthPage = currentRoute.includes('/login') ||
                         currentRoute.includes('/register') ||
                         currentRoute.includes('/reset-password');
      
      if (!isAuthPage) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        
        // Redirect to login page
        if (Capacitor.isNativePlatform()) {
          window.location.hash = '/login';
        } else {
          window.location.href = '/login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
